import React,{useEffect} from 'react';
import HeaderSec from '../components/HeaderSec';
import Footer from '../components/Footer';
import PaymentMethods from '../components/PaymentMethods';
import CookiesPopup from '../components/CookiesPopup';
import WhatsappChat from '../components/WhatsappChat';
import ScrollTop from '../components/ScrollTop';
import ContactIcon from '../components/ContactIcon';
import Title from "../components/Title";
import ContactUs from '../components/ContactUs';
import ContactMap from '../components/ContactMap';
import ContactBanner from '../components/contact/ContactBanner';

const Contact = () => {
    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant"
        });
      }, []);
        return(
            <>
            <Title title="Contact | CAD AND RENDER" />
            <HeaderSec />

            <ContactBanner />

            <div className='cadContactMaincontent cadGallerycontent cadAboutContent'>
                <div className='container'>
                    <p>At CAD and RENDER, we specialize in providing high-quality jewelry 3D CAD Designing and Realistic Rendering services to jewelry manufacturers, wholesalers and retailers. With years of experience in the industry, we have become experts in our craft and are dedicated to providing exceptional service to our clients.</p>
                </div>
            </div>

            <ContactIcon />
            <WhatsappChat />
            <ScrollTop />
            <CookiesPopup />

            <ContactUs />

            <ContactMap />

            <PaymentMethods />
            

            <Footer />
            </>
        )
}


export default Contact;